export default {
  vessel: { name: 'Vessel', desc: 'There are some reason build the site lorem ipsum dolor sit amet.' },
  heatExchanger: { name: 'Heat Exchanger', desc: 'There are some reason build the site lorem ipsum dolor sit amet.' },
  piping: { name: 'Piping', desc: 'There are some reason build the site lorem ipsum dolor sit amet.' },
  mufle: { name: 'Mufle', desc: 'There are some reason build the site lorem ipsum dolor sit amet.' },
  radiantTube: { name: 'Radiant Tube', desc: 'There are some reason build the site lorem ipsum dolor sit amet.' },
  otherEquipment: { name: 'Other Equipment', desc: 'There are some reason build the site lorem ipsum dolor sit amet.' },
  fabricationOf: 'Fabrication of',
  readMore: 'READ MORE',
};
